module.exports = {
  "Gattaran_V1__YaIb": "En línea",
  "Gattaran_V1__xaNO": "Tasa de cancelación",
  "FoodB_Commision_Type_of_EIWZ": "Tipo de tienda",
  "FoodB_0926__pZyK": "No hay promociones en curso",
  "FoodB_Show_ID_Card_BrxO": "Cédula de identidad",
  "FoodB_Analysis_Yesterday_nearly_aBCt": "Ayer",
  "FoodB_030_zOTR_tsWu": "Mi zona",
  "FoodC_intostore_Store_Coupon_kHwh": "Cupones de la tienda",
  "FoodB_calculator_ULXU_HjOF": "IVA",
  "Gattaran_visit_PQZP_gcOK": "Sí",
  "Gattaran_REGULAR_xhms_NLbn": "Restablecer",
  "FoodB_NewStore_Status_HphC": "Estado",
  "FoodB_up20241218_aEPD_NaLf": "Seleccionar artículos",
  "FoodB_calculator_WKKD_DbHM": "Base gravable de pagos en línea",
  "FoodB_Commision_Add_MPEf": "Agregar",
  "FoodB_list_Store_Phone_tSWo": "Número de teléfono de la tienda",
  "FoodB_calculator_CXvv_RJgQ": "Monto a recibir antes de impuestos y comisión",
  "FoodD_Questionnaire_Finished_YvLk": "Listo",
  "FoodB_202204_Number_of_yYUn": "Pedidos con calificación negativa",
  "FoodB_030_fqBt_uzDV": "Faltan permisos: {{City}}. Solicita un permiso en Gattaran.",
  "Gattaran_visit_KNGQ_NwUQ": "El BD enlista los acuerdos anteriores",
  "FoodB_tagging_You_chose_OMGB": "Decidiste invalidar este socio potencial por el siguiente motivo: \"La tienda no existe\". Para hacerlo, debes cargar una foto.",
  "FoodB_communications_mtxm_YcRA": "tiendas que no completaron las acciones para el impulso de tiendas nuevas",
  "FoodB_calculator_gRHL_Sgok": "Margen de utilidad",
  "FoodB_202311_VkTS_OoIy": "Vencida",
  "FoodB_communications_ZlRD_aGjm": "día(s) faltante(s)",
  "FoodB_email_KYaO_tHVJ": "Operador de la app",
  "FoodB_Show_Savings_uvSS": "Cuenta de ahorros",
  "FoodB_0_Please_upload_ziBz": "Carga una captura de pantalla del historial de llamadas",
  "FoodB_phrase__NpWx": "Sólo promos finalizadas en los últimos {{number}} meses",
  "FoodB_0322_gUpY_CIHG": "No hay tiendas que coincidan con los filtros",
  "FoodD_payout_Company_Registration_zoVW": "Cédula Jurídica",
  "FoodB_data_Beginning_PbJC": "Hora de inicio",
  "FoodB_list_Apply_for_RxQn": "Solicitar firma",
  "FoodB_audit_Distance_between_BRSw": "Distancia entre la tienda anterior y la nueva",
  "FoodB_field_Is_you_uNye": "¿Sujeto al pago del IVA nacional?",
  "FoodB_0905__dSOH": "Diagnóstico de la tienda",
  "FoodB_420241024_LTYv_GOfN": "Valor final",
  "FoodB_optimization_Label_nzNw": "Etiqueta",
  "FoodB_leads_Artificial_labcategory_UNzu": "Categoría de etiqueta manual",
  "FoodB_Launch_DR_Military_Rxvi": "Cédula Militar",
  "FoodC_orderlist_Completed_Xuod": "Finalizado",
  "FoodB_P0_cNyW_HkyE": "Cambios en pedidos completados",
  "FoodB_calculator_hPAw_BZlP": "Impuesto cedular",
  "FoodB_Show_Store_Direct_GuJM": "Contrato firmado mediante B-App",
  "FoodB_leads_The_relationship_jkYA": "Hora ideal para contactar",
  "FoodB_list_Store_ID_GNUR": "No. de identificación de la tienda",
  "FoodOpB_Management_Appeals_foxk": "Solicitar revisión",
  "FoodB_optimization__bdZL": "La imagen debe tener un formato JPG o PNG, pesar menos de 5 MB y ser de al menos 200×200 píxeles.",
  "FoodB_20230410_YNjt_xAWA": "Tienda DiDi Top",
  "FoodB_Launch_DR_Foreigner_gXpW": "Cédula Extranjera",
  "FoodB_system_offline_revV": "Fuera de línea",
  "FoodB_210811_No_tax_QkcN": "Falta un documento fiscal",
  "FoodC_sales_Confirmation_mTGd": "Entendido",
  "FoodB_0926__bEjZ": "No hay promociones iniciadas",
  "FoodB_model20250116_wlQy_yyEp": "Hora de la visita",
  "FoodB_v1_Sources_of_DsXR": "Fuente de información",
  "FoodB_CL_Individuals_VUHt": "Persona física",
  "FoodB_list_Setting_Up_YlBy": "set_open_duration",
  "FoodB_b_Source_of_qGPd": "Origen del evento",
  "FoodB_list_Brand_Name_pGTc": "Nombre de la marca",
  "FoodB_0_Please_upload_roTo": "Carga una captura de pantalla del historial de correo electrónico",
  "FoodB_calculator_HXix_qhAK": "ISR sobre base gravable",
  "FoodB_email_NJBQ_LwUX": "Este contacto no tiene un correo electrónico registrado, por lo que no se le pueden enviar este tipo de mensajes. Por favor, agrega un correo electrónico y vuelve a seleccionarlo.",
  "FoodB_V2_Satisfied_with_YFEM": "Satisfecha con la situación actual",
  "FoodD_Name_April_UHuR": "Abr",
  "FoodB_420241024_mWia_Agjc": "No se logró",
  "FoodB_calculator_WFgZ_JmvX": "Calculadora de pagos",
  "FoodB_phrase__PWcd": "No hay promos finalizadas para ver",
  "Gattaran_V1__hUDQ": "Servicio",
  "FoodB_0_Please_upload_BZIQ": "Carga una captura de pantalla del historial de chat",
  "FoodB_Show_Current_NJqK": "Cuenta corriente",
  "FoodB_email_AhaC_FOft": "Otro contacto",
  "FoodB_CL_power_of_KgHH": "Contrato de mandato",
  "Gattaran_visit_Zykg_WdpB": "El BD preparó la visita",
  "FoodB_1__gcdX": "Datos del evento",
  "FoodB_list_KP_Phone_qQCQ": "Teléfono del representante de la tienda",
  "FoodB_up20241218_WbCj_pCMp": "Registro previo para la promoción de artículos en promoción de tienda nueva",
  "FoodD_payout_Account_Type_YmVW": "Tipo de cuenta",
  "FoodB_I_Home_OrRo": "Inicio",
  "FoodB_tagging_You_chose_lWSH": "Decidiste invalidar este socio potencial por el siguiente motivo: \"No es una tienda de venta minorista\". Para hacerlo, debes estar a menos de {{distance}} de la tienda. Verifícalo e inténtalo de nuevo.",
  "FoodC_replace_Clear_Filter_iwTY": "Borrar filtros",
  "FoodB_030_SQUQ_YDRS": "No mis tiendas",
  "FoodB_0905__qppX": "{{number}} pedidos menos que antes",
  "FoodB_V2_dLkl_pbiF": "Para realizar esta acción, actualiza la aplicación a la versión más reciente.",
  "FoodD_Name_September_Ezci": "Sep",
  "FoodB_model20250116_innF_fIuu": "Visita exitosa",
  "FoodB_email_CBNM_cSdr": "Correo electrónico",
  "FoodD_Name_December_Ykas": "Dic",
  "FoodB_V2_Illegal_companies_pXwb": "No registrada legalmente",
  "Gattaran_REGULAR_bTIM_MAXe": "El valor no puede ser mayor a 1000",
  "Gattaran_Grocery__pKzk": "Shop",
  "FoodB_model20250116_PRsL_yJEl": "Por favor, elige al menos {{num_required_fields}}",
  "FoodB_0622_Increase_store_kZfr": "Agregar comparación de tiendas",
  "FoodB_calculator_GdDU_bFgc": "Subsidio DiDi",
  "FoodOpB_CRM_Party_B_BCQp": "Número de identificación de la empresa",
  "Gattaran_REGULAR_XlOa_yzqB": "Resultado",
  "FoodB_calculator_QGtY_JOsw": "Inversión de la tienda sobre el descuento total",
  "FoodB_calculator_BKfQ_ehtA": "Comisión DiDi",
  "FoodB_0_Mail_SUKZ": "Correo electrónico",
  "FoodD_Name_January_lhYr": "Ene",
  "FoodB_email_SdUD_YAhg": "Falta la información del representante de la tienda. Por favor, agrégala para poder enviar el correo electrónico.",
  "FoodB_communications_nVMa_oikA": "Impulso para tiendas nuevas",
  "FoodD_Storefront_YFcS_cnUy": "DiDi Negocio",
  "FoodD_Compliance_About_to_fTcV": "Vence pronto",
  "FoodB_audit_Store_Information_ryuV": "Se realizó una revisión de la información modificada de la tienda",
  "FoodB_calculator_VKAb_KHst": "Subsidio DiDi",
  "FoodD_Name_May_zYiz": "May",
  "FoodOpB_CRM_Taxpayer_Address_ptqR": "Dirección del  contribuyente (Local)",
  "FoodB_calculator_VujK_GJbV": "Utilidad",
  "FoodB_list_KP_Name_GQRs": "Nombre del representante de la tienda",
  "FoodB_calculator_mTaD_pjZv": "Descuento total",
  "FoodD_Name_June_sECU": "Jun",
  "FoodC_c_Completed_djPp": "Finalizado",
  "FoodB_Launch_Illegal_import_jlOS": "Entrada no válida",
  "FoodB_communications_APfO_DcRl": "Acciones no completadas para el impulso de tiendas nuevas",
  "FoodD_Name_November_BcWL": "Nov",
  "FoodB_list_Recently_launched_IWDa": "Última vez conectada",
  "FoodB_Show_Taxpayer_Document_eadz": "Tipo de documento tributario (local)",
  "FoodB_calculator_tLev_cAgO": "Pago en línea",
  "FoodB_method_hwZM_aUnb": "Descargar Explorer",
  "FoodB_model20250116_dVSj_sFUN": "Esperando revisión",
  "FoodB_new1_Name_similarity_gepH": "Similitud del nombre",
  "FoodB_up20241218_Btbi_AOsy": "Enviado",
  "Gattaran_REGULAR_TWeg_lFbm": "Este campo es obligatorio",
  "FoodB_Wordings_MYHl_FXti": "Selecciona un motivo",
  "FoodD_supplement_Rules_RYAa": "Reglas",
  "FoodB_email_qCka_NBMf": "Hora preferida para contactar",
  "FoodD_Incentive_In_progress_GNvs": "En curso",
  "FoodB_tagging_You_chose_DSiT": "Decidiste invalidar este socio potencial por el siguiente motivo: \"Operaciones detenidas\". Para hacerlo, debes cargar una foto o el número de contacto del representante de la tienda.",
  "FoodB_20231012_GZve_uPZM": "Ya se establecieron las reglas de cálculo de la fecha límite para este tipo de tarea. Por favor, no vuelvas a ingresarlas.",
  "FoodB_1__IhgO": "Actualizado el {{time}}",
  "FoodB_2_Visit_Records_LiJy": "Resumen de visitas",
  "FoodB_diagnosis_Items_qQOR": "artículo(s)",
  "FoodB_optimization_Contract_No_GvBj": "Núm. de ident. del contrato",
  "FoodB_0919__YKYU": "Sin promociones",
  "FoodB_calculator_mdtN_KpDW": "Descuento total",
  "FoodB_Analysis_Nearly_7_wumh": "Últimos {{day}} días",
  "FoodB_2_During_the_QHhU": "Periodo de registro",
  "FoodB_202204_Order_eJXF": "Pedidos",
  "FoodB_field_No_need_hToz": "Opcional",
  "FoodB_2__YqWB": "Motivo del rechazo",
  "FoodB_switch_yJQj_DSir": "Participando en promociones 100% financiadas",
  "FoodB_0919__RZJo": "Pedidos completados",
  "FoodB_SMS__promotion_EKZy": "Promoción de entrega sin costo",
  "FoodB_2_Planned_bPON": "Plan",
  "FoodB_up250108_BLxC_rIzf": "Ver después",
  "FoodB_orders_Select_Store_gtmG": "Seleccionar tiendas",
  "FoodB_Wordings_iyFv_fDmW": "Comentarios adicionales",
  "FoodB_audit_Suspected_duplicate_ntLx": "Posible tienda duplicada",
  "FoodB_store_Order_Coupon_zpSY": "Cupón de reembolso de pedido",
  "FoodB_0905__zFVs": "Peso total",
  "FoodB_calculator_CcKA_weRh": "Para propósitos referenciales únicamente: el pago final a las tiendas estará sujeto a deducciones por cancelaciones, temas de posventa y otros motivos.",
  "Gattaran_visit_zdKK_wwRk": "Resultados de la visita",
  "Gattaran_visit_opSF_XPmM": "El BD trae objetivos claros a la visita",
  "Gattaran_REGULAR_ezuA_ZuBN": "Identificación fiscal",
  "FoodB_calculator_Vzvw_WmgN": "Método de pago",
  "FoodB_calculator_rMFF_EMXI": "Efectivo",
  "FoodB_audit_Review_process_vGtV": "proceso de revisión. ¿Estás seguro de que quieres continuar?",
  "FoodB_Show_Taxpayer_Document_TFeg": "Tipo de documento tributario (nacional)",
  "FoodB_2_Call_visit_NGFu": "Teléfono",
  "FoodB_I_Cancelled_orders_XeVk": "Pedidos cancelados",
  "FoodB_calculator_giVW_AULQ": "Precio unitario de la plataforma",
  "FoodB_IGV_iopU_urly": "IGV",
  "FoodB_calculator_vEpj_lLGl": "Descuento total",
  "FoodB_1__GxZN": "Últimos 30 días",
  "FoodB_calculator_EeIc_TwiG": "Persona moral",
  "FoodB_0_WhatsApp_dmMD": "WhatsApp",
  "FoodD_Name_October_WGkU": "Oct",
  "FoodD_Name_March_cqIc": "Mar",
  "FoodB_optimization_Stimulate_contact_xSSH": "Método de contacto preferido",
  "FoodB_calculator_HfHr_bkLf": "Subsidio de DiDi sobre el descuento total",
  "FoodB_Launch_DR_ID_AnVk": "Cédula Dominicana",
  "FoodB_CL_Vista_Account_QcOm": "Cuenta Vista",
  "Gattaran_visit_hZGE_sfuk": "Retroalimentación general",
  "FoodB_0707_High_prices_fBsL": "Más altos",
  "FoodB_Show_Tax_payment_xfxh": "Forma de pago de impuestos (Nacional)",
  "FoodB_0921__isZD": "Tasa de artículos calificados",
  "FoodB_0919__mVqa": "Demoras en la entrega",
  "FoodB_optimization_Buy_gifts_daUI": "Compra X, llévate Y gratis",
  "FoodB_communications_HAnw_bYAw": "tiendas con acciones incompletas",
  "FoodB_I_onwf_oaQH": "Ventas",
  "FoodB_calculator_UUgW_xBLd": "Cantidad de artículos",
  "Gattaran_V1__ccGl": "Últimos 30 días",
  "FoodB_Part1_Store_Name_jrHD": "Nombre del restaurante",
  "FoodC_cash_WQNI_uYzC": "Agregar",
  "Gattaran_visit_nNId_fOhX": "La visita del BD fue efectiva",
  "Gattaran_REGULAR_irYR_Bntt": "Si no estás seguro de si tu número de identificación fiscal es válido, cópialo y compruébalo en el sitio web oficial que se indica a continuación:",
  "FoodB_progress_ZdQT_mHfK": "Restablecer",
  "FoodB_calculator_Jryi_aded": "Personería fiscal",
  "FoodB_420241024_FldG_feZL": "Valor objetivo",
  "FoodB_2_Store_XkLQ": "Tienda",
  "FoodB_0919__CONM": "Artículos no disponibles",
  "FoodB_0622_Select_up_QXDl": "Selecciona hasta 2 tiendas",
  "FoodC_revision_Less_meal_pHwq": "Error en pedido",
  "FoodB_model20250116_HPUj_zcce": "No se encontró la ubicación. No es posible marcar la hora de ingreso o salida. Por favor, activa los servicios de ubicación en la configuración del teléfono y permite que la aplicación de BD acceda a ellos.",
  "FoodB_420241024_rQXh_ONDO": "Se logró",
  "FoodB_0_Please_upload_dcPG": "Carga una captura de pantalla del historial de mensajes de texto",
  "FoodB_system_Competition_NFPY": "Competidor",
  "FoodB_Show_Subject_Information_RFOj": "Información del Representante Legal/Propietario",
  "FoodB_tagging_You_chose_aZCG": "Decidiste invalidar este socio potencial por el siguiente motivo: \"Operaciones detenidas\". Para hacerlo, debes estar a menos de {{distance}} de la tienda. Verifícalo e inténtalo de nuevo.",
  "FoodB_CL_Add_any_egRn": "Es aceptable cualquiera de los siguientes tres documentos:\nPoder del Representante Legal\nCertificado de Comercio de Registro de Santiago (o ciudad respectiva)\nCertificado de Estatuto Actualizado",
  "FoodB_Show_Company_Registration_VcVV": "Cédula Jurídica",
  "FoodB_resivion_Feedback_to_QmQU": "Repórtalo a tu supervisor para que la modifique",
  "FoodB_management_Untied_tYEF": "Desvincular",
  "FoodB_0926__Jfhv": "No hay promociones con este estado",
  "FoodB_0920__QnBO": "Requisitos no cumplidos",
  "Gattaran_visit_kYQA_ZYsK": "El BD maneja bien las objeciones de la tienda",
  "FoodB_model2025011603_ztWt_rarX": "Por favor, selecciona primero el método de visita y el tipo de visita",
  "FoodB_communications_UOIk_QdZg": "Realiza las acciones para el impulso de tiendas nuevas para obtener ventajas adicionales. Las acciones vencen en {{task_left_days}} día(s)",
  "FoodB_resivion_Skip_qpSD": "Omitir",
  "FoodB_model20250116_IADF_eXfa": "Hora de salida",
  "FoodOpB_Management_You_can_aDLi": "Para crear la tienda nueva de todos modos, haz clic en “solicitar revisión”. Ten en cuenta que la revisión puede tomar hasta 2 días.",
  "FoodB_0907__jtsj": "No hay datos del diagnóstico",
  "FoodOpB_CRM_Card_holder_NfIL": "Ingresa el número de identificación del beneficiario",
  "FoodB_audit_Similarity_check_cQEP": "Evaluación de similitud",
  "FoodB_calculator_RWNx_Xkrf": "Persona física",
  "FoodB_email_Lqnd_eyfn": "Acuerdos y comentarios",
  "FoodOpB_CRM_Taxpayer_full_fzhk": "Nombre completo del contribuyente (Nacional)",
  "FoodB_0622_The_statistical_NUCJ": "Los datos se calculan con base en T+1 y se organizan de acuerdo al volumen de ventas de los artículos en los últimos 30 días",
  "FoodB_0830__wEQD": "Pedidos completados en este mes",
  "FoodB_CL_Simple_company_JBRG": "Sociedad de sistema simplificado",
  "Gattaran_visit_xnVQ_bENu": "Objetivos a mejorar",
  "FoodB_calculator_yiXt_NkiM": "Comisión DiDi",
  "FoodB_Show_Foreign_DIMEX_LKxF": "DIMEX",
  "FoodB_I_UlHM_KKLT": "Pedidos",
  "FoodB_calculator_cctL_sltb": "Total del pedido",
  "FoodB_0921__iLXg": "Cantidad",
  "FoodB_Show_Aliens_Residence_creU": "Cédula de Residencia",
  "FoodB_0905__pNYF": "Los pedidos se superponen. La suma no refleja el total de pedidos completados cada día.",
  "FoodB_20231012_Usvn_HuCU": "La tarea se creó con éxito. Puedes seguir el progreso en el módulo Mis tareas.",
  "FoodB_0622_Store_management_ztNB": "Operaciones de la tienda",
  "FoodB_0919__etPs": "Múltiples promociones",
  "FoodB_0623_Store_GZFE": "Tienda",
  "Gattaran_V1__zewR": "Menú",
  "FoodB_email_WcaT_rLqN": "El resultado de la visita está incompleto. Por favor, ingresa el resultado de la visita antes de continuar con la optimización.",
  "FoodOpB_Management_High_similarity_lnFn": "Ya existe una tienda similar",
  "FoodB_Launch_DR_Passport_JChW": "Pasaporte",
  "FoodB_communications_udno_SENU": "Hay una o más promociones pendientes de aceptación. Participar en las promociones podría ayudar a impulsar las ventas.",
  "FoodB_calculator_lSyU_ySZI": "¿La tienda está ubicada en Guanajuato?",
  "FoodB_2__CkLu": "La misma ciudad",
  "FoodB_calculator_JGZb_tQiY": "Precio para el usuario",
  "FoodB_email_FvUP_tJQT": "Nombre",
  "FoodB_field_Do_you_mhOz": "¿Sujeto al pago del IVA local?",
  "FoodB_communications_hhCR_kEAh": "tiendas que tienen acciones a realizar esta semana",
  "FoodB_0905__yxOa": "Sin cambios",
  "FoodB_CL_Letter_of_EmKs": "Foto del Contrato de Mandato",
  "FoodB_202207_Default_BQmA": "Predeterminado",
  "FoodB_0113_ELbg_zfBg": "Ver info. sobre el asesor de la tienda aquí",
  "FoodB_resivion_Inaccurate_information_dmRA": "¿Hay alguna información incorrecta?",
  "FoodB_Analysis_Old_people_fwCy": "Usuarios recurrentes",
  "FoodB_calculator_pEyx_wJvY": "Sí",
  "FoodB_0905__wwdP": "Peso de subartículo",
  "FoodB_0820__bVDh": "Alta prioridad",
  "FoodB_field_Needs_IbzB": "Obligatorio",
  "Gattaran_REGULAR_luKX_QwKw": "Entrada de impuesto de México",
  "FoodB_0905__ccXH": "Periodo del diagnóstico",
  "FoodC_improve__ByLg": "Diferente a lo esperado",
  "FoodB_V2_DQvR_Redp": "Usa la función para compartir en la app de BD.",
  "Gattaran_visit_Wpaf_mvuG": "El BD cerró los acuerdos exitosamente",
  "FoodB_up20241218_dJSA_yyZX": "Confirmar",
  "FoodB_0905__Uuug": "Reglas del diagnóstico",
  "FoodB_CL_Traditional_companies_cQhK": "Sociedad de sistema tradicional",
  "FoodB_executors20241225_bYiY_UfOD": "Lógica de asignación automática",
  "soda-b-homepage-i18n---首位必须是1，必须输入11位": "El primer dígito debe ser 1 y se deben ingresar 11 dígitos.",
  "FoodB_0905__vMsv": "{{number}} pedidos más que antes",
  "FoodB_I_QuSz_HsAZ": "Descuento de promo %",
  "FoodOpB_CRM_Taxpayer_Tax_xOmZ": "N° del  contribuyente (Local)",
  "Gattaran_REGULAR_KZHa_qJOa": "Ingresa un número entero",
  "FoodB_IV_Tips_DFOG": "Alerta",
  "FoodB_audit_The_information_jxLV": "La información que enviaste no cumple con los requisitos",
  "FoodB_420241024_TFhQ_lSww": "Se rechazó correctamente",
  "FoodB_optimizing_Duplicate_Store_aBYS": "Número de identificación de restaurante duplicado",
  "FoodB_model20250116_pAHl_Vjqs": "No aprobada",
  "FoodB_calculator_hmWL_DEwB": "No",
  "FoodD_Name_August_cjQS": "Ago",
  "FoodB_0_SMS_yOMB": "Mensajes de texto",
  "FoodB_calculator_VFoE_zsGK": "Costo del artículo",
  "Gattaran_REGULAR_OPsx_JMnf": "Calcular",
  "FoodD_Name_February_bMVM": "Feb",
  "FoodB_V2_No_bank_plEI": "Faltan los datos bancarios",
  "FoodB_list_Name_of_dxYm": "Nombre del representante de ventas",
  "FoodB_Show_Final_Tax_XQQi": "Definitivo",
  "Gattaran_REGULAR_UodO_bJVP": "El valor no puede ser mayor a 100",
  "FoodB_V2_No_store_ahBo": "Falta RFC (Registro Federal de Contribuyentes) *only mx",
  "FoodB_up20241218_VRuL_OZqJ": "Registro previo de la promo",
  "FoodB_0623_Indicators_auar": "KPI",
  "FoodB_audit_The_strings_NPFx": "Hacer clic en confirmar iniciará el proceso de revisión \"{{strings}}\". No se puede solicitar la firma del contrato hasta completada la revisión. ¿Deseas continuar?",
  "FoodB_tagging_You_have_ssrJ": "Decidiste invalidar este socio potencial por el siguiente motivo: \"No es una tienda de venta minorista\". Para hacerlo, debes cargar una foto o el número de contacto del representante de la tienda.",
  "Gattaran_REGULAR_JVAQ_pbxi": "Entrada básica",
  "FoodB_model20250116_QHad_xAWm": "Tipo de visita",
  "FoodC_improve__ovBF": "Porciones pequeñas",
  "FoodB_up20241218_ZADd_MrpU": "Por favor, selecciona entre uno y cinco artículos. No pueden seleccionarse artículos o bebidas con alcohol.",
  "FoodB_email_SHyg_fIzy": "Falta el correo electrónico del representante de la tienda. Por favor, agrégalo para enviar el correo.",
  "Gattaran_V1__ZtqD": "Ver tutorial de promociones",
  "FoodB_model20250116_GjAr_XZPC": "Hora de ingreso",
  "FoodOpB_CRM_Type_of_fbmW": "Tipo de identificación del beneficiario",
  "FoodB_audit_New_and_yYux": "Diferencia entre el nombre anterior de la tienda y el nuevo",
  "FoodB_V2_Failure_to_sQaD": "No cumple con los requisitos",
  "Gattaran_visit_CRcg_FwpW": "No",
  "FoodB_Show_Tax_payment_Dbuz": "Forma de pago de impuestos (Local)",
  "FoodB_calculator_pQIn_LdhF": "¿La identificación fiscal es válida?",
  "FoodD_AccountInfoCollection_Got_it_QvNt": "Entendido",
  "FoodB_0622_Contrast_jVys": "Comparar",
  "FoodB_Show_Special_Tax_Eidl": "NITE (Número de Identificación Tributaria Especial)",
  "Gattaran_resivion_More_KTYU": "Más",
  "FoodOpB_CRM_Taxpayer_full_tMpR": "Nombre completo del contribuyente (Local)",
  "FoodB_0707_Lifted_off_tnXl": "No disponible",
  "FoodB_communications_BCnM_evHy": "tiendas que tienen acciones a realizar esta semana para el impulso de tiendas nuevas",
  "FoodB_leads_KP_Phone_hCUe": "Teléfono 2 del representante del restaurante",
  "FoodB_Launch_DR_Temporary_BQFH": "Permiso residencia temporal",
  "FoodB_0830__BIGT": "Visitas en este mes",
  "FoodB_email_qdfP_heFs": "¡Hola! Visitamos tu tienda {{store_name}} y revisamos lo siguiente junto con {{person_to_be_visited}}:",
  "FoodB_Wordings_DKwT_wbfI": "Indica por qué elegiste esta opción. Tus comentarios son valiosos y nos ayudan a mejorar.",
  "FoodB_calculator_AioF_coBc": "IVA sobre base gravable",
  "FoodB_new1_Similarity_ItET": "Similitud",
  "FoodB_time_No_permission_Xxyy": "Sin permisos",
  "Gattaran_visit_jnPQ_METw": "¿La persona que toma decisiones estuvo presente en la visita?",
  "FoodB_V2_iZpC_KKcK": "Compartir reporte de diagnóstico con la tienda",
  "FoodB_0113_ZcCF_NbjE": "Puedes agregar un plan de visita aquí",
  "FoodB_supplement_No_data_jUGB": "Sin datos",
  "FoodB_up20241218_hGVF_hBSj": "Esta tienda no tiene artículos que cumplan con los requisitos. Sugerimos contactar a la tienda pronto para cargar los artículos.",
  "FoodB_0905__uatF": "Mayor que {{number_or_rate}} tiendas cercanas",
  "FoodB_Show_Special_residence_ezfV": "Permiso Especial de Permanencia",
  "FoodB_audit_Review_Opportunity_ZQHk": "Revisión de la información básica del socio potencial editada",
  "FoodB_0921__kEaD": "Subsidio%",
  "FoodB_CL_RUT_roUA": "RUT",
  "FoodB_email_Cebi_VpDl": "Teléfono",
  "FoodB_Analysis_New_customers_vYDl": "Usuarios nuevos",
  "FoodB_up250108_UapS_ZXgM": "Ver ahora",
  "FoodB_audit_Click_OK_Zfsf": "Si das en confirmar, se activará el",
  "FoodB_email_Zgsh_mNSy": "KP",
  "FoodB_optimization_Full_reduction_NlOa": "Gasta X, Ahorra Y",
  "FoodB_email_mlcn_NvDS": "Método preferido de contacto",
  "FoodB_data_End_mVwX": "Hora de cierre",
  "FoodB_optimization_Special_Meal_YtqD": "Artículos en promoción",
  "FoodB_2_Online_visit_OLuR": "Presencial",
  "FoodB_0327_ZGTe_zcKH": "Pulsa aquí para cambiar de ciudad",
  "FoodB_resivion_Overdue_visit_jTHW": "Visitas vencidas",
  "FoodB_calculator_TJJY_SkoH": "Inversión de la tienda",
  "FoodB_0905__kaPI": "Calificación del diagnóstico",
  "FoodOpB_CRM_Taxpayer_Address_EBwy": "Dirección del contribuyente (Nacional)",
  "Gattaran_V1__WcTv": "Tasa de artículos calificados",
  "FoodB_model20250116_iVfy_zMbV": "Ingreso registrado con éxito",
  "FoodB_IGV_WGYF_kfvV": "IGV",
  "Gattaran_visit_KjUG_kxHP": "El BD enlista los programas promocionales y revisa las necesidades de la tienda",
  "FoodD_Name_July_RJXL": "Jul",
  "FoodB_0919__flip": "Artículos disponibles",
  "FoodB_0622_Sales_KRCg": "Volumen de ventas",
  "FoodB_email_Bwgs_muyN": "Empleado",
  "FoodB_audit_Audit_process_asoS": "proceso de revisión. No podrás solicitar una firma hasta que se complete este proceso. ¿Estás seguro de que quieres continuar?",
  "FoodB_calculator_dsiQ_vhFJ": "Monto a recibir",
  "FoodB_tagging_You_chose_tIKm": "Decidiste invalidar este socio potencial por el siguiente motivo: \"La tienda no existe\". Para hacerlo, debes estar a menos de {{distance}} de la tienda. Verifícalo e inténtalo de nuevo.",
  "Gattaran_V1__SttS": "Promociones",
  "FoodB_model20250116_TRTm_agBI": "Volver",
  "FoodB_calculator_ydSg_ejbp": "IVA",
  "FoodB_V2_No_legal_QONX": "Falta la identificación del representante legal",
  "FoodB_2__FNaI": "La misma zona objetivo"
}